import styles from "../../../../Shared/ConfirmationDetailCard/ConfirmationDetailCard.module.css";
import { palette, Card, Select, IOption } from "@powerdiary/components-library/lib";
import { Box, useTheme } from "@mui/material";
import { Gift } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { selectBooking, setClient, useClientPortalDispatch, useClientPortalSelector } from "../../../../../redux";
import { BookingStatus } from "../../../bookingSlice.types";

import { AppointmentBookingClientModel } from "types/generated/models";

interface IConfirmationAppointmentForCardProps {
    relatedClients: AppointmentBookingClientModel[];
}

export default function ConfirmationAppointmentForCard({ relatedClients }: IConfirmationAppointmentForCardProps) {
    const theme = useTheme();
    const { confirmation, session } = useClientPortalSelector(selectBooking);
    const dispatch = useClientPortalDispatch();

    const isBookingCompleted = session.bookingStatus === BookingStatus.BOOKED;
    const completedData = session.completedBookingData;

    const clientId =
        isBookingCompleted && completedData
            ? completedData.confirmation?.client?.id
            : (confirmation.data?.client?.id ?? relatedClients[0]?.id);

    const [selectedClientId, setSelectedClientId] = useState<number>(clientId);

    const relatedClientOptions: IOption[] = useMemo(() => {
        return relatedClients.map((client) => ({ label: client.name, value: client.id.toString() }));
    }, [relatedClients]);

    useEffect(() => {
        const selectedClient = relatedClients.find((client) => client.id === clientId);
        if (selectedClient) {
            dispatch(setClient(selectedClient));
        }
    }, [clientId, dispatch, relatedClients]);

    const handleClientChange = (newValue: string) => {
        setSelectedClientId(Number(newValue));
        const selectedClient = relatedClients.find((client) => client.id === Number(newValue));
        if (selectedClient) {
            dispatch(setClient(selectedClient));
        }
    };

    return (
        <Card
            className={`${styles.wrapper}`}
            sx={{ backgroundColor: palette.neutral["50"], padding: "12px" }}
            data-test-id={`section_confirmation_detail_card_appointment_for`}
        >
            <Box className={styles.contentWrapper}>
                <Box className={styles.iconContainer} data-test-id="icon_confirmation_detail_card_appointment_for">
                    <Gift
                        className={styles.icon}
                        color={theme.palette.primary.main}
                        size={20}
                        strokeWidth={2}
                        aria-hidden
                    />
                </Box>
                <Box className={styles.textContainer}>
                    <Select
                        options={relatedClientOptions}
                        onChange={(changeEvent) => handleClientChange(changeEvent.target.value)}
                        label="Appointment for:"
                        value={selectedClientId}
                    />
                </Box>
            </Box>
        </Card>
    );
}
